import * as React from 'react';
import { Route, Switch } from 'react-router-dom';

import { useKeycloak } from '@react-keycloak/web';

import LoginPage from '../pages/Login';
import MyRecords from '../pages/MyRecords/List';
import SupervisionList from '../pages/Supervision/List';
import Requests from '../pages/Requests';
import RecordsList from '../pages/Records/List';
import RecordsDetail from '../pages/Records/Show';
import Loader from '../components/Loader';
import PatientsList from '../pages/Patients/List';
// import GroupsList from '../pages/Groups/List';
import InitialForm from '../pages/Forms/Init';
import ParentInitialForm from '../pages/Forms/ParentInit';
import AdoptionForm from '../pages/Forms/Adoption';
import UpdateForm from '../pages/Forms/Update';
import EvaluationForm from '../pages/Forms/Evalutation';
import SocialServiceForm from '../pages/Forms/SocialService';
import ParentsForm from '../pages/Forms/Parents';
import PsychopedagogyForm from '../pages/Forms/Psychopedagogy';
import DiscountForm from '../pages/Forms/Discount';
import DiagnosisForm from '../pages/Forms/Diagnosis';
import PsychiatricForm from '../pages/Forms/Psychiatric';
import QuarterForm from '../pages/Forms/QuarterPlan';
import ForwardForm from '../pages/Forms/Forward';
import FoodForwardForm from '../pages/Forms/FoodForward';
import GroupForwardForm from '../pages/Forms/GroupForward';
import ClinicForwardForm from '../pages/Forms/ClinicForward';
import ClosureForm from '../pages/Forms/Closure';
import Signature from '../pages/Signature';
import Settings from '../pages/Settings';
import Screening from '../pages/Forms/Screening';
import BabyScreening from '../pages/Forms/BabyScreening';
import Evolution from '../pages/Forms/Evolution';
import Hosting from '../pages/Forms/Hosting';
import NutritionEvolution from '../pages/Forms/NutritionEvolution';
import PsychiatryEvolution from '../pages/Forms/PsychiatryEvolution';
import ConsultantRequestForm from '../pages/Forms/ConsultantRequest';
import DeclarationForm from '../pages/Forms/Declaration';
import HelpdeskList from '../pages/Helpdesk/List';
import HelpdeskNew from '../pages/Helpdesk/New';
import HelpdeskShow from '../pages/Helpdesk/Show';

import PrivateRoute from './privateRoute';

export enum RealmRoles {
  ADMIN = 'admin',
  PROFESSIONAL = 'professional',
  SUPERVISOR = 'supervisor',
  APPROVER = 'approvers',
  RESEARCH = 'research',
}

export const AppRouter: React.FC = () => {
  const { initialized } = useKeycloak();

  if (!initialized) {
    return <Loader loading={!initialized} />;
  }

  return (
    <Switch>
      <Route
        exact
        path="/formularios/inicial/:formId"
        component={InitialForm}
      />
      <Route
        exact
        path="/formularios/inicial-responsaveis/:formId"
        component={ParentInitialForm}
      />
      <Route
        exact
        path="/formularios/inicial-adocao/:formId"
        component={AdoptionForm}
      />
      <Route
        exact
        path="/formularios/atualizacao-cadastral/:formId"
        component={UpdateForm}
      />
      <Route exact path="/assinatura" component={Signature} />
      <Route exact path="/conta" component={Settings} />
      <PrivateRoute exact path="/" component={MyRecords} />
      <PrivateRoute
        exact
        path="/meus-prontuarios"
        component={MyRecords}
        role={RealmRoles.PROFESSIONAL}
      />
      <PrivateRoute
        exact
        path="/supervisao"
        component={SupervisionList}
        role={RealmRoles.SUPERVISOR}
      />
      <PrivateRoute
        exact
        path="/aprovacoes"
        component={Requests}
        role={RealmRoles.APPROVER}
      />
      <PrivateRoute
        exact
        path="/prontuarios"
        component={RecordsList}
        role={RealmRoles.ADMIN}
      />
      <PrivateRoute
        exact
        path="/meus-prontuarios/:id"
        component={(props: any) => <RecordsDetail {...props} />}
      />
      <PrivateRoute exact path="/prontuarios/:id" component={RecordsDetail} />
      <PrivateRoute
        exact
        path="/prontuarios/:id/formularios/inicial/:formId"
        component={InitialForm}
      />
      <PrivateRoute
        exact
        path="/prontuarios/:id/formularios/atualizacao-cadastral/:formId"
        component={UpdateForm}
      />
      <PrivateRoute
        exact
        path="/prontuarios/:id/formularios/inicial-adocao/:formId"
        component={AdoptionForm}
      />
      <PrivateRoute
        exact
        path="/prontuarios/:id/formularios/inicial-responsaveis/:formId"
        component={ParentInitialForm}
      />
      <PrivateRoute
        exact
        path="/prontuarios/:id/formularios/avaliacao"
        component={EvaluationForm}
      />
      <PrivateRoute
        exact
        path="/prontuarios/:id/formularios/avaliacao/:formId"
        component={EvaluationForm}
      />

      <PrivateRoute
        exact
        path="/prontuarios/:id/formularios/encaminhamento-servico-social"
        component={SocialServiceForm}
      />
      <PrivateRoute
        exact
        path="/prontuarios/:id/formularios/encaminhamento-servico-social/:formId"
        component={SocialServiceForm}
      />
      <PrivateRoute
        exact
        path="/prontuarios/:id/formularios/encaminhamento-transtornos-alimentares"
        component={FoodForwardForm}
      />
      <PrivateRoute
        exact
        path="/prontuarios/:id/formularios/encaminhamento-transtornos-alimentares/:formId"
        component={FoodForwardForm}
      />

      <PrivateRoute
        exact
        path="/prontuarios/:id/formularios/encaminhamento-setor-grupos"
        component={GroupForwardForm}
      />
      <PrivateRoute
        exact
        path="/prontuarios/:id/formularios/encaminhamento-setor-grupos/:formId"
        component={GroupForwardForm}
      />

      <PrivateRoute
        exact
        path="/prontuarios/:id/formularios/encaminhamento-corpo-clinico"
        component={ClinicForwardForm}
      />
      <PrivateRoute
        exact
        path="/prontuarios/:id/formularios/encaminhamento-corpo-clinico/:formId"
        component={ClinicForwardForm}
      />
      <PrivateRoute
        exact
        path="/prontuarios/:id/formularios/consultoria-transtornos-alimentares"
        component={ConsultantRequestForm}
      />
      <PrivateRoute
        exact
        path="/prontuarios/:id/formularios/consultoria-transtornos-alimentares/:formId"
        component={ConsultantRequestForm}
      />
      <PrivateRoute
        exact
        path="/prontuarios/:id/formularios/encaminhamento-atendimento-pais"
        component={ParentsForm}
      />
      <PrivateRoute
        exact
        path="/prontuarios/:id/formularios/encaminhamento-atendimento-pais/:formId"
        component={ParentsForm}
      />

      <PrivateRoute
        exact
        path="/prontuarios/:id/formularios/encaminhamento-psicopedagogia"
        component={PsychopedagogyForm}
      />
      <PrivateRoute
        exact
        path="/prontuarios/:id/formularios/encaminhamento-psicopedagogia/:formId"
        component={PsychopedagogyForm}
      />

      <PrivateRoute
        exact
        path="/prontuarios/:id/formularios/encaminhamento-terapeuta"
        component={ForwardForm}
      />
      <PrivateRoute
        exact
        path="/prontuarios/:id/formularios/encaminhamento-terapeuta/:formId"
        component={ForwardForm}
      />

      <PrivateRoute
        exact
        path="/prontuarios/:id/formularios/encerramento-atendimento"
        component={ClosureForm}
      />
      <PrivateRoute
        exact
        path="/prontuarios/:id/formularios/encerramento-atendimento/:formId"
        component={ClosureForm}
      />

      <PrivateRoute
        exact
        path="/prontuarios/:id/formularios/reducao-valor"
        component={DiscountForm}
      />
      <PrivateRoute
        exact
        path="/prontuarios/:id/formularios/reducao-valor/:formId"
        component={DiscountForm}
      />

      <PrivateRoute
        exact
        path="/prontuarios/:id/formularios/psicodiagnostico"
        component={DiagnosisForm}
      />
      <PrivateRoute
        exact
        path="/prontuarios/:id/formularios/psicodiagnostico/:formId"
        component={DiagnosisForm}
      />

      <PrivateRoute
        exact
        path="/prontuarios/:id/formularios/avaliacao-psiquiatrica"
        component={PsychiatricForm}
      />
      <PrivateRoute
        exact
        path="/prontuarios/:id/formularios/avaliacao-psiquiatrica/:formId"
        component={PsychiatricForm}
      />

      <PrivateRoute
        exact
        path="/prontuarios/:id/formularios/revisao-semestral-plano"
        component={QuarterForm}
      />
      <PrivateRoute
        exact
        path="/prontuarios/:id/formularios/revisao-semestral-plano/:formId"
        component={QuarterForm}
      />

      <PrivateRoute
        exact
        path="/prontuarios/:id/formularios/parecer-triagem"
        component={Screening}
      />
      <PrivateRoute
        exact
        path="/prontuarios/:id/formularios/parecer-triagem/:formId"
        component={Screening}
      />

      <PrivateRoute
        exact
        path="/prontuarios/:id/formularios/parecer-triagem-intervencoes-precoces"
        component={BabyScreening}
      />

      <PrivateRoute
        exact
        path="/prontuarios/:id/formularios/parecer-triagem-intervencoes-precoces/:formId"
        component={BabyScreening}
      />

      <PrivateRoute
        exact
        path="/prontuarios/:id/formularios/evolucao-mensal-ambientoterapia"
        component={Evolution}
      />
      <PrivateRoute
        exact
        path="/prontuarios/:id/formularios/evolucao-mensal-ambientoterapia/:formId"
        component={Evolution}
      />

      <PrivateRoute
        exact
        path="/prontuarios/:id/formularios/acolhimento"
        component={Hosting}
      />
      <PrivateRoute
        exact
        path="/prontuarios/:id/formularios/acolhimento/:formId"
        component={Hosting}
      />

      <PrivateRoute
        exact
        path="/prontuarios/:id/formularios/evolucao-mensal-nutricao"
        component={NutritionEvolution}
      />
      <PrivateRoute
        exact
        path="/prontuarios/:id/formularios/evolucao-mensal-nutricao/:formId"
        component={NutritionEvolution}
      />

      <PrivateRoute
        exact
        path="/prontuarios/:id/formularios/evolucao-psiquiatrica"
        component={PsychiatryEvolution}
      />
      <PrivateRoute
        exact
        path="/prontuarios/:id/formularios/evolucao-psiquiatrica/:formId"
        component={PsychiatryEvolution}
      />

      <PrivateRoute
        exact
        path="/prontuarios/:id/formularios/declaracao"
        component={DeclarationForm}
      />
      <PrivateRoute
        exact
        path="/prontuarios/:id/formularios/declaracao/:formId"
        component={DeclarationForm}
      />

      <PrivateRoute
        path="/pacientes"
        component={PatientsList}
        role={RealmRoles.RESEARCH}
      />

      <PrivateRoute exact path="/helpdesk" component={HelpdeskList} />
      <PrivateRoute exact path="/helpdesk/novo" component={HelpdeskNew} />
      <PrivateRoute exact path="/helpdesk/:id" component={HelpdeskShow} />

      {/* <PrivateRoute
        path="/setores"
        component={GroupsList}
        role={RealmRoles.ADMIN}
      /> */}
      <Route path="/login" component={LoginPage} />
    </Switch>
  );
};
